import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';

export default function EmailConfirm() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('waiting');
  const [resending, setResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');
  const [email, setEmail] = useState(searchParams.get('email') || '');
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      api.get(`/auth/confirm?token=${token}`)
        .then(() => { navigate('/login?confirmed=1'); })
        .catch(() => setStatus('error'));
    }
  }, [token]);

  const handleResend = async () => {
    if (!email) return;
    setResending(true); setResendMessage('');
    try {
      const res = await api.post('/auth/resend-confirmation', { email });
      setResendMessage(res.data.message || 'Письмо отправлено');
    } catch (err) {
      setResendMessage(err.response?.data?.message || 'Ошибка отправки');
    }
    setResending(false);
  };

  if (token) {
    if (status === 'error') {
      return (
        <div className="auth-container">
          <div className="auth-card">
            <h2>Ошибка подтверждения</h2>
            <p>Не удалось подтвердить email. Попробуйте запросить ссылку повторно.</p>
            <button onClick={() => navigate('/login')} style={{ marginTop: '16px' }}>На страницу входа</button>
          </div>
        </div>
      );
    }
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h2>Подтверждение...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Подтвердите email</h2>
        <p>На ваш email отправлено письмо с ссылкой для подтверждения.</p>
        <p>Пожалуйста, проверьте почту и перейдите по ссылке.</p>
        <div style={{ marginTop: '16px' }}>
          <input type="email" placeholder="Ваш email" value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: '100%', padding: '8px', marginBottom: '8px', boxSizing: 'border-box' }} />
          <button onClick={handleResend} disabled={resending || !email}>
            {resending ? 'Отправка...' : 'Отправить повторно'}
          </button>
          {resendMessage && <p style={{ marginTop: '8px' }}>{resendMessage}</p>}
        </div>
        <button onClick={() => navigate('/login')} style={{ marginTop: '16px' }}>На страницу входа</button>
      </div>
    </div>
  );
}